// SchedaLiberatorie.tsx — nel profilo: le liberatorie firmate (con il PDF) e, se ce n'è una da firmare, il link.
// Non compare se non c'è nessuna liberatoria attiva e non se ne è mai firmata una. v035: «da firmare» solo per i tester
// (la liberatoria serve per usare i video di chi riprendiamo nella pubblicità, non per giocare né per condividere):
// gli altri la vedono solo se l'hanno già firmata (per il PDF).
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { leggiLiberatoria, liberatorieMie, scaricaPdfLiberatoria, type FirmaMia } from "../servizi/liberatoria.ts";
import { eBooleano, leggiImpostazione } from "../servizi/impostazioni.ts";
import { vai } from "../servizi/percorso.ts";
import { IMP_APP, PERCORSO_LIBERATORIA } from "../costanti.ts";
import { nomeNativo } from "../i18n/index.ts";
import { useAccount } from "../servizi/account.ts";

export function SchedaLiberatorie() {
  const { t, i18n } = useTranslation();
  const [mie, setMie] = useState<FirmaMia[]>([]);
  const [daFirmare, setDaFirmare] = useState(false);
  const [errore, setErrore] = useState(false);
  const account = useAccount();
  const tester = account.tipo === "registrato" && account.io.tester === true;
  const attiva = leggiImpostazione(IMP_APP.liberatoriaAttiva, false, eBooleano) && tester;

  useEffect(() => {
    let vivo = true;
    void (async () => {
      const m = await liberatorieMie().catch(() => []);
      const testo = attiva ? await leggiLiberatoria(i18n.language).catch(() => null) : null;
      if (!vivo) return;
      setMie(m);
      // v029: firmata in una lingua qualsiasi tra quelle attive = già firmata
      const attive = testo ? (testo.lingue?.map((l) => l.versione) ?? [testo.versione]) : [];
      setDaFirmare(testo !== null && !m.some((f) => attive.includes(f.versione)));
    })();
    return () => {
      vivo = false;
    };
  }, [attiva, i18n.language]);

  if (!mie.length && !daFirmare) return null;
  const data = new Intl.DateTimeFormat(i18n.language, { dateStyle: "medium" });
  return (
    <section className="scheda-account scheda-liberatorie">
      <h2 className="scheda-titolo">{t("liberatoria.titolo_profilo")}</h2>
      {/* v042: due righe che spiegano perché dare il permesso */}
      <p className="nota">{t("liberatoria.profilo_spiega")}</p>
      {daFirmare && (
        <button type="button" className="pulsante pulsante-secondario" onClick={() => vai(PERCORSO_LIBERATORIA)}>
          {t("liberatoria.da_firmare")}
        </button>
      )}
      <ul className="elenco-identita">
        {mie.map((f) => (
          <li key={f.id}>
            <span>
              {f.titolo}{" "}
              <span className="nota">
                · v{f.versione}
                {f.lingua && f.lingua !== i18n.language ? ` · ${nomeNativo(f.lingua)}` : ""} · {data.format(new Date(f.firmata_il))}
              </span>
            </span>
            <button type="button" className="pulsante-link" onClick={() => void scaricaPdfLiberatoria(f.id).catch(() => setErrore(true))}>
              {t("liberatoria.pdf")}
            </button>
          </li>
        ))}
      </ul>
      {errore && (
        <p className="admin-errore" role="alert">
          {t("account.errore_generico")}
        </p>
      )}
    </section>
  );
}
